import React, { Component } from 'react'
import Radio from './Radio'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import RawHtml from 'stories/components/RawHtml'
import {
  replaceObjKey,
  getNumbersInRange,
} from '../../../helpers/generalHelpers'
import { isRtl } from '../../../settings'
import { defineMessages, injectIntl } from 'react-intl'
import clsx from 'clsx'
import FieldWrapper from '../FieldRowWrapper'
import MuiRadioInput from './MuiRadioInput'
import OtherOptionInput from './OtherOptionInput'

import './radio-input.css'

if (isRtl) {
  require('./radio.rtl.css')
} else {
  require('./radio.ltr.css')
}

const messageDefinitions = defineMessages({
  yes: { id: 'general.yes' },
  no: { id: 'general.no' },
})

const replacer = replaceObjKey({ slug: 'value', title: 'name' })

class RadioInput extends Component {
  constructor(props) {
    super(props)
    this.state = { selected: '' }
  }

  onInputChange = ({ selectedOptions, shouldUpdateParent }) => {
    this.setState({ selected: selectedOptions }, () => {
      shouldUpdateParent && this.props.onChange(selectedOptions)
    })
  }

  onOption = (selectedOptions) => {
    this.onInputChange({
      selectedOptions,
      shouldUpdateParent: true,
    })
  }

  componentDidMount = () => {
    // makes this component hybrid, if there is a value prop
    // it will respect it but otherwise it is independent 🍺👍
    const { value } = this.props
    if (value) {
      this.onInputChange({
        selectedOptions: value,
        shouldUpdateParent: false,
      })
    }
  }

  generateOptions = (options = [], type) => {
    return options.map((option, index) => (
      <Radio
        key={option.value + index}
        {...option}
        onCheck={this.onOption}
        checked={option.value === this.state.selected}
        type={type}
      />
    ))
  }

  getFromIntl = (property) =>
    this.props.intl.formatMessage(messageDefinitions[property])

  otherChoiceInput = () => (
    <OtherOptionInput
      key={`${this.props.slug}-otherChoice`}
      uniqueName={this.props.slug}
      onChange={this.onOption}
      name={this.props.name}
      selectedValue={this.state.selected}
    />
  )

  defaultYesNoOptions = [
    { value: 'yes', name: this.getFromIntl('yes') },
    { value: 'no', name: this.getFromIntl('no') },
  ]

  likeDislikeOptions = [
    { value: -1, icon: 'dislike' },
    { value: 1, icon: 'like' },
  ]

  npsOptions = () =>
    // valid range: 0 <=> 10
    getNumbersInRange(
      Number(this.props.range_start || 0),
      Number(this.props.range_end || 10)
    ).map((num) => ({ value: num, name: num }))

  render() {
    const {
      label = '',
      options = [],
      required,
      touched,
      error,
      description,
      type,
      min_message,
      max_message,
      customized,
      has_other_choice: hasOtherChoice,
    } = this.props

    const classNames = {
      'formz-radio-input': true,
      'formz-has-focus': this.state.hasFocus,
      'formz-has-error': this.props.error,
      'full-width': this.props.fullWidth,
    }

    const renamedOptions = options.map(replacer)

    const choiceType = {
      yes_no: this.defaultYesNoOptions,
      like_dislike: this.likeDislikeOptions,
      nps: this.npsOptions(),
    }

    if (customized)
      return (
        <FieldRowWrapper
          className={classNames}
          error={error}
          touched={touched ? touched.toString() : undefined}
        >
          <div className="formz-field-and-label-holder">
            <div className="formz-input-title">
              {label} {required && '(*)'}
            </div>

            <RawHtml
              className="formz-field-description"
              content={description}
            />

            <div
              className={clsx({
                'formMaker-formz-radio-group-container': true,
                ' formz-input-field': true,
                'score-container': type === 'nps' ? true : false,
              })}
            >
              {this.generateOptions(
                choiceType[type] ? choiceType[type] : renamedOptions,
                type
              )}
              {hasOtherChoice && this.otherChoiceInput()}
            </div>
            {type === 'nps' && (
              <div className="min-max-message">
                <span>{min_message}</span>
                <span>{max_message}</span>
              </div>
            )}
          </div>
        </FieldRowWrapper>
      )

    return (
      <FieldWrapper
        error={error}
        touched={touched ? touched.toString() : undefined}
        fullWidth={this.props.fullWidth}
      >
        <MuiRadioInput onChange={this.onInputChange} {...this.props} />
      </FieldWrapper>
    )
  }
}

export default injectIntl(RadioInput)
